import axios from 'axios';

const api = axios.create({
    baseURL: 'https://homolog.api.mandeseguro.com.br/api',
});

export default api;
